import request from '@/utils/request'

// 校验套餐
export function checkPackage(phone,useService) {
    return request({
        url: 'member/package/check/'+phone+"/"+useService,
        method: 'get'
    })
}
